<script lang="ts"></script>

<a class="skip-link" href="#content">Skip to content</a>

<style lang="css">
  .skip-link {
    position: absolute;
    left: -9999px;
    top: auto;
    width: 1px;
    height: 1px;
    overflow: hidden;
  }
</style>